import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Layout from "@/components/Layout";
import { ContentProvider } from "@/lib/content-context";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import AirlinePartnersPage from "@/pages/AirlinePartnersPage";
import AirZimbabwePage from "@/pages/AirZimbabwePage";
import DestinationsPage from "@/pages/DestinationsPage";
import DestinationDetailPage from "@/pages/DestinationDetailPage";
import TravelAgentPage from "@/pages/TravelAgentPage";
import CorporateGroupPage from "@/pages/CorporateGroupPage";
import ServicesPage from "@/pages/ServicesPage";
import ServiceDetailPage from "@/pages/ServiceDetailPage";
import ContactCentrePage from "@/pages/ContactCentrePage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import NotFoundPage from "@/pages/NotFoundPage";
import AdminLoginPage from "@/pages/AdminLoginPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import OfferLondonHararePage from "@/pages/OfferLondonHararePage";
import TravelAgentRegistrationPage from "@/pages/TravelAgentRegistrationPage";

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <ContentProvider>
            <Layout>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/airline-partners" element={<AirlinePartnersPage />} />
                <Route path="/airline-partners/air-zimbabwe" element={<AirZimbabwePage />} />
                <Route path="/destinations" element={<DestinationsPage />} />
                <Route path="/destinations/:slug" element={<DestinationDetailPage />} />
                <Route path="/travel-agent-centre" element={<TravelAgentPage />} />
                <Route path="/travel-agent-registration" element={<TravelAgentRegistrationPage />} />
                <Route path="/corporate-groups" element={<CorporateGroupPage />} />
                <Route path="/services" element={<ServicesPage />} />
                <Route path="/services/:slug" element={<ServiceDetailPage />} />
                <Route path="/contact-centre" element={<ContactCentrePage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms" element={<TermsPage />} />
                <Route path="/offers/london-harare" element={<OfferLondonHararePage />} />
                <Route path="/admin/login" element={<AdminLoginPage />} />
                <Route path="/admin" element={<AdminDashboardPage />} />
                <Route path="*" element={<NotFoundPage />} />
              </Routes>
            </Layout>
          </ContentProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
